"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _AccountSelectContainer = require("./AccountSelectContainer");
var _registerOrAuthorizeByToken = require("../../../../types/phoneAuth/registerOrAuthorizeByToken");
var _phoneAuth = require("../../../../actions/phoneAuth");
var _phoneAuth2 = require("../../../../types/phoneAuth");
var _view = require("../../../../actions/view");
function mapStateToProps(state) {
  const {
    accounts,
    phoneАccounts
  } = state.phoneAuth.registerOrAuth;
  const {
    account,
    status: authByTokenStatus
  } = state.phoneAuth.authenticateByToken;
  const {
    status
  } = state.phoneAuth.registerOrAuthByToken;
  const {
    phone
  } = state.phoneAuth;
  const {
    view,
    source
  } = state;
  return {
    view,
    source,
    phone,
    accounts,
    phoneАccounts,
    loadableAccount: account,
    continueByAccountLoading: authByTokenStatus === _phoneAuth2.EAuthenticateByTokenStatus.Loading,
    continueByPhoneLoading: status === _registerOrAuthorizeByToken.ERegisterOrAuthByTokenStatus.Loading
  };
}
function mapDispatchToProps(dispatch) {
  return {
    continueByAccount(params) {
      dispatch((0, _phoneAuth.authenticateByToken)(params));
    },
    continueByPhone() {
      dispatch((0, _phoneAuth.registerOrAuthorizeByToken)());
    },
    changeView(view, data) {
      dispatch((0, _view.changeView)(view, data));
    }
  };
}
const AccountSelectContainer = exports.AccountSelectContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AccountSelectContainer.AccountSelectContainer);